import {
  ActivatableItemSummaryInterface,
  AppPrices,
  ChildApp,
  ItemType,
  ListActivatableItemsFilters,
  ListActivatableItemsRequest,
} from '@vendasta/marketplace-apps';
import { InventoryItem } from '../common/inventory-item';
import { InventoryItemEdition } from '../common/inventory-item/item-types/app';

export interface ItemSelectorRowItem extends ActivatableItemSummaryInterface {
  itemId: string;
  appPrices?: AppPrices;
  isSelected?: boolean;
  editionId?: string;
  quantity?: number;
  editions?: Edition[];
  itemType?: ItemType;
  immutable?: boolean;
  unavailableInCountry?: boolean;
  pricesInitialized?: boolean;
  childApps?: ChildApp[];
}

export interface Edition extends InventoryItemEdition {
  appId: string;
  isActive?: boolean;
}

export type SelectedItem = InventoryItem & {
  immutable?: boolean;
};

export interface ItemSelectorConfig {
  partnerId?: string;
  marketId?: string;
  businessId?: string;
  pageSize?: number;
  country?: string;
  priceType?: 'generic' | 'instance';
  hideOwnerName?: boolean;
  hideWholesale?: boolean;
  hideRetail?: boolean;
  hideQuantity?: boolean;
  hideItemsWithOrderForms?: boolean;
  itemTypesAvailable?: ItemSelectorFilterType[];
  enforceDependencies?: boolean;
}

export type ItemSelectorFilterType = 'products' | 'packages';

export enum SelectionChangeEventType {
  SELECTED,
  DESELECTED,
}

export interface SelectionChange {
  selectedItems: SelectedItem[];
  updatedItem: SelectedItem;
  eventType: SelectionChangeEventType;
}

export type ItemSelectorFilters = Omit<
  ListActivatableItemsFilters,
  'searchTerm' | 'itemType' | 'ownerPartnerId' | 'toApiJson'
>;

export interface ItemSelectorState {
  itemType: 'products' | 'packages' | 'allItems';
  requiredItem: ItemSelectorRowItem | null;
  showAddons: boolean;
  showUnavailableItems: boolean;
}

export type FilterFn = (req: ListActivatableItemsRequest) => ListActivatableItemsRequest;
